import { render, staticRenderFns } from "./VerMenuEleItem.vue?vue&type=template&id=575b9327&scoped=true"
import script from "./VerMenuEleItem.vue?vue&type=script&lang=js"
export * from "./VerMenuEleItem.vue?vue&type=script&lang=js"
import style0 from "./VerMenuEleItem.vue?vue&type=style&index=0&id=575b9327&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575b9327",
  null
  
)

export default component.exports